module.exports = __webpack_public_path__ + "img/slider-1.c1e7735b.png";